import React, { Component, Fragment } from 'react';
import {connect} from 'react-redux';
import { CONFIG, CONFIG_API_BE, URL_AKM} from '../../../../../config';
import {cekCookies} from '../../../../../actions';
import __ from 'lodash';
import LoaderModal from '../../../../modal/LoaderModal';
import Navbar from '../../../navbar/Navbar';
import Sidebar from '../../../sidebar/Sidebar';
import akmApi from '../../../../../apis/akmApi';

import ListAllJadwalProfilCbt from './ListAllJadwalProfilCbt';

import Snackbar from '@material-ui/core/Snackbar'
import Alert from '@material-ui/lab/Alert';
import { Grid, Typography } from '@material-ui/core';

class JadwalProgramHub extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: true,
            message: null,
            detailPaketProgram: this.props.history.location.state.detailPaketProgram
        }
    }

    async componentDidMount(){
        await this.props.cekCookies();
        if(!__.isEmpty(this.props.account)) {
            
        }     
    }

    handleIsFetching = async (bool) =>{
        this.setState({isFetching: bool});
    }

    render(){
        const {isFetching, detailPaketProgram} = this.state;
        return(
            <div className="wrapper">
                <LoaderModal isFetching={isFetching} />
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    {this.loadSnackbar()}
                    <Navbar title={"Paket Program <=> Jadwal Profil"}/>
                    <Typography variant="h6" color="textPrimary">{detailPaketProgram.namaProgram}</Typography>
                    <ListAllJadwalProfilCbt 
                        detailPaketProgram={detailPaketProgram}
                        handleIsFetching={this.handleIsFetching}
                    />
                </div>
            </div>
        )
    }


    loadSnackbar = () => {
        const {isSnackbar, codeError, message } = this.state;      
        return (
            <Snackbar
                anchorOrigin={{
                vertical: '',
                horizontal: '',
                }}                
                open={isSnackbar}
                autoHideDuration={5000} 
                onClose={() => this.setState({ isSnackbar: false })}>
                <Alert onClose={() => this.setState({ isSnackbar: false })} severity={codeError == 'EP-000' ? 'success' : 'error'}>
                    <b>{message}</b>
                </Alert>
            </Snackbar>
        );
    }

}
const mapStateToProps = (state) => {
    return{
        account: state.account       
    };
}

export default connect(mapStateToProps, {cekCookies})(JadwalProgramHub);